import * as React from 'react';
import { useDayPicker } from "../../contexts";
/** Render the Footer component (empty as default).*/

export function Footer() {
  var _a = useDayPicker(),
      footer = _a.footer,
      styles = _a.styles,
      tfoot = _a.classNames.tfoot;

  if (!footer) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement("tfoot", {
    className: tfoot,
    style: styles.tfoot
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 8
  }, footer)));
}